<div class="scrollable">
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Alive</th>
        <th scope="col">Version</th>
        <th scope="col">Status info</th>
        <th scope="col">URL</th>
        <th scope="col">Admin URL</th>
      </tr>
    </thead>
    <tbody>
      @for (service of services; track service) {
        <tr>
          <th scope="row">{{ service.role }}</th>
          <td>{{ this.aliveMap.get(service) }}</td>
          <td>{{ getVersionString(service) }}</td>
          <td>
            @if (getStatusString(service).length > 10) {
              <span
                placement="right"
                ngbPopover="{{ getStatusString(service) }}"
                popoverTitle="{{ service.role }}"
                triggers="mouseenter:mouseleave">
                {{ getStatusValuesCount(service) }} values
              </span>
            } @else {
              <!-- show http error codes directly -->
              <span>
                {{ getStatusString(service) }}
              </span>
            }
          </td>
          <td>{{ service.publicUri }}</td>
          <td>{{ service.adminUri }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
